import ValidateStep from "./validateStep"

/**
 * ValidateStep3 class
 * @extends ValidateStep
 * @classdesc This class is used to validate the third step of the form - checks all at the end
 */
export default class ValidateStep3 extends ValidateStep {
    constructor(cPM, user, btn) {
        super(cPM, user, btn)
        this.cPM = cPM
        this.adress = document.querySelector("#powermail_field_aadress")
        this.message = document.querySelector("#powermail_field_message")
        this.continueButton = btn
        this.errorField = document.querySelector(".powermail_fieldwrap_errorlist-step3")
        this.setEventsForAllInputs()
        this.initButton()
    }

    // we need:
    // powermail_fieldwrap_checkout_display
    // powermail_fieldwrap_agb

    /**
     * validates all fields of the third step
     */
    setEventsForAllInputs() {
        // console.log("TODO: setEventsForAllInputs validateStep3");
    }

    /**
     * initializes the event for the submit button
     * @returns {void}
     */
    initButton() {
        if (this.continueButton) {
            this.continueButton.addEventListener("click", (e) => {
                // call validate in child
                this.validate()
                if (!this.valid) {
                    e.preventDefault()
                    this.cPM.secondStep()
                    this.showError()
                    console.warn("validateStep 3: validation failed", this.valid)
                } else {
                    this.hideError()
                    // console.log("validateStep 3: validation successful", this.valid)
                }
            })
        }
    }
}
